import { useEffect, useState } from "react";
import axios from "axios";
import { FadeIn } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LAYOUTS = [
  { span: "md:col-span-8", ratio: "aspect-[16/10]" },
  { span: "md:col-span-4", ratio: "aspect-square" },
  { span: "md:col-span-4", ratio: "aspect-[4/5]" },
  { span: "md:col-span-4", ratio: "aspect-square" },
  { span: "md:col-span-4", ratio: "aspect-square" },
  { span: "md:col-span-6", ratio: "aspect-[4/3]" },
  { span: "md:col-span-6", ratio: "aspect-[4/3]" },
];

export default function Gallery() {
  const [uploaded, setUploaded] = useState(null); // null = loading, [] = empty

  useEffect(() => {
    axios
      .get(`${API}/photos`)
      .then(({ data }) => setUploaded(data || []))
      .catch(() => setUploaded([]));
  }, []);

  const shots = (uploaded || []).map((p, i) => ({
    src: p.url,
    title: p.title,
    ...LAYOUTS[i % LAYOUTS.length],
  }));

  return (
    <main data-testid="gallery-page" className="pt-32 pb-24">
      <section className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <FadeIn>
          <div className="stamp mb-8">Vol · VI · Archive</div>
          <h1 className="font-display text-6xl md:text-8xl leading-[0.95] text-[#F2E7D0] max-w-5xl">
            An <em className="italic text-[#D97645]">archive</em> of the estate.
          </h1>
        </FadeIn>
      </section>

      <section className="mx-auto max-w-[1600px] px-6 lg:px-12 py-16 grid grid-cols-4 md:grid-cols-12 gap-4">
        {shots.map((s, i) => (
          <FadeIn key={i} delay={(i % 4) * 0.06} className={`col-span-4 ${s.span}`}>
            <div className="group relative overflow-hidden bg-[#27221C]">
              <img src={s.src} alt={s.title || ""} className={`w-full ${s.ratio} object-cover vintage-img group-hover:scale-[1.02] transition-transform duration-700`} />
              {s.title && (
                <div className="absolute bottom-0 inset-x-0 p-4 bg-gradient-to-t from-[#1C1913]/90 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="font-display text-xl text-[#F2E7D0]">{s.title}</div>
                </div>
              )}
            </div>
          </FadeIn>
        ))}
        {uploaded && uploaded.length === 0 && (
          <p className="col-span-4 md:col-span-12 text-center text-[#B8A891] font-mono-label text-sm py-16">
            More photographs on their way.
          </p>
        )}
      </section>
    </main>
  );
}
